<script lang="ts">

	let prodColors: boolean = import.meta.env.MODE == 'production' || import.meta.env.MODE == 'demo';
</script>

<header class="">
	<div
		style="height: 9px;"
		class="w-full bg-gradient-to-r {prodColors
			? 'from-secondary-100 to-secondary-300'
			: 'from-yellow to-orange dark:from-secondary-500 dark:to-secondary-400'}"
	></div>
	<div
		style="width: 16px; height: 16px"
		class="absolute top-0 right-0 {prodColors
			? 'bg-secondary-300 '
			: 'bg-orange dark:bg-secondary-400'}"
	></div>
	<svg style="width: 16px; right: 8px; top: 9px;" class="absolute">
		<circle cx="8px" cy="8px" r="8px" class="fill-white dark:fill-dark-100" />
	</svg>
	<div
		style="width: 8px; height: 36px;"
		class="absolute top-0 right-0 {prodColors
			? 'bg-secondary-300'
			: 'bg-orange dark:bg-secondary-400'}"
	></div>
	<svg style="width: 8px; top: 36px;" class="absolute right-0">
		<circle
			cx="8px"
			cy="0px"
			r="8px"
			class={prodColors ? 'fill-secondary-300' : 'fill-orange dark:fill-secondary-400'}
		/>
	</svg>


</header>

<!--Env indicator-->
{#if import.meta.env.MODE !== 'production' && import.meta.env.MODE !== 'demo'}
	<p
		style="font-size: 30px; opacity: 0.07;"
		class="absolute bottom-2 left-4 text-2l font-bold text-red dark:text-orange uppercase select-none pointer-events-none"
	>
		{import.meta.env.MODE}
	</p>
{/if}
